const SummaryCardGrid = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <div className="grid items-center w-full grid-cols-2 gap-4 pr-2 mt-2 lg:grid-cols-4">
      {data.map((card, i) => (
        <div
          key={i}
          className="w-full shadow-[4px_4px_20px_0px_#00000040] h-[100px] rounded-[12px] p-3 flex flex-col justify-between"
        >
          <div className="flex flex-row items-start justify-between">
            <div className="flex flex-col gap-3">
              <span className="text-[10px] font-medium font-inter leading-[100%] tracking-[-0.03em] text-black">
                {card.label}
              </span>
              <span className="text-[22px] font-bold font-inter leading-[100%] text-black">
                {card.count}
              </span>
            </div>
            <div
              className={`w-[30px] h-[30px]  rounded-full flex items-center justify-center ${card.bgColor}`}
            >
              <img
                src={card.icon}
                alt={card.label}
                className="w-[18.67px] h-[18.67px]"
              />
            </div>
          </div>

          <div className="flex items-center mt-2">
            <img
              src={
                card.trend === "up"
                  ? "/icons/green-arrowUp.png"
                  : "/icons/red-arrowDown.png"
              }
              alt="trend icon"
              className="w-[18px] h-[18px]"
            />
            <span
              className={`w-[30px] pt-1 h-[17px] text-[10px] text-center font-normal font-inter leading-[100%] rounded ${
                card.trend === "up" ? "text-[#22C55E]" : "text-[#FF1F1F]"
              }`}
            >
              {card.trendValue}
            </span>
            <span className="font-inter font-normal text-black text-opacity-60 text-[10px] leading-[100%] tracking-[0%]">
              {card.timeline}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCardGrid;
